import '.ak{position:relative;}.ssr-plugin'
import '.c1{margin-bottom:-2rem;}.ssr-plugin'
import { PageLayout } from '@app/pages/layout/PageLayout'
import Column from '@app/components/layout/Column'
import { Text } from '@app/components/core/typography/Text'
import { PageBreadcrumbs } from '@app/components/blocks/pageBreadcrumbs/PageBreadcrumbs'
import { PageMediaGallery } from '@app/components/blocks/mediaGallery/PageMediaGallery'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { DataCard } from './sections/DataCard'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { styled } from 'inlines'
import { useMemo } from 'react'
import { buildEventJsonLd } from '@app/util/seo/buildEventJsonLd'
import { useRootDomain } from '@app/util/hooks/useRootDomain'
import { useTranslations } from '@i18n/useLanguage'
import { ViewEventModel } from 'functions/app/event/view'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { Title } from '@app/components/core/typography/Title'
import { ItemListCardItem } from '@app/components/blocks/card/ItemListCard'

export const EventPageMobile = ({ event }: { event: ViewEventModel }) => {
  const t = useTranslations().app
  const [_, navigate] = useLocation()
  const eventImages = useMemo(() => event?.images ?? [], [event?.images])
  const rootDomain = useRootDomain()

  const eventJsonLd = useMemo(() => {
    if (!event) {
      return undefined
    }
    return buildEventJsonLd({
      event,
      rootDomain,
    })
  }, [event, rootDomain])

  const organiser = useMemo(
    () =>
      event.initiative?.title &&
      event.initiative?.slug &&
      event.initiative?.images?.[0]?.src
        ? {
            title: event.initiative.title,
            image: event.initiative.images[0].src,
            onClick: () => {
              navigate(pages.initiative(event.initiative.slug))
            },
          }
        : undefined,
    [event.initiative, navigate],
  )

  return (
    <PageLayout gap="0rem" marginTop="0rem">
      <PageSeo
        pageTitle={event.title}
        description={event.intro}
        image={eventImages[0]}
        jsonLd={eventJsonLd}
      />
      <Column alignItems="stretch" gap="1.5rem">
        <PageBreadcrumbs level2={t.pageNames.agenda} level3={event.title} />
        <div className="ak c1">
          <PageMediaGallery
            style={{ width: '100%' }}
            title={event.title}
            images={eventImages}
            defaultImage={defaultProjectPicture}
          />
          <DataCard
            event={event}
            style={{ position: 'relative', top: '-2rem' }}
          />
        </div>

        <Text.Medium>{event.content}</Text.Medium>

        {organiser && (
          <Column>
            <Title.H4 style={{ marginBottom: 0 }}>
              {t.eventPage.organisers}
            </Title.H4>
            <ItemListCardItem item={organiser} />
          </Column>
        )}
      </Column>
    </PageLayout>
  )
}
